import axios from "axios";

const PRIMARY_URL = process.env.REACT_APP_API_BASE_URL || "https://www.aacoreholidaysresort.com/api";
const FALLBACK_URL = process.env.REACT_APP_API_LOCAL_URL || "http://localhost:8000/api";

const AxiosInstance = axios.create({
  baseURL: PRIMARY_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor for debugging
AxiosInstance.interceptors.request.use(
  (config) => {
    console.log("Making request to:", (config.baseURL || "") + config.url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor - fallback to local server on network error ONLY in development
AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If live server fails with network error and we haven't retried yet, try localhost only in development mode
    if (
      process.env.NODE_ENV === "development" &&
      error.code === "ERR_NETWORK" &&
      !originalRequest._retried &&
      originalRequest.baseURL === PRIMARY_URL
    ) {
      console.log("Live server unreachable, trying local server...");
      originalRequest._retried = true;
      originalRequest.baseURL = FALLBACK_URL;
      return axios(originalRequest);
    }

    console.error("API Error:", {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    return Promise.reject(error);
  }
);

export default AxiosInstance;
